import { AdvanceFilter } from '../../jobs/models/advance-filter';
import { JobFilter } from './../../jobs/models/job-filter';
export class JobMappings {

  public static MapAdvFilterToJobFilter = (source: AdvanceFilter, dest: JobFilter) => {
    if(!dest) {
      dest = new JobFilter();
    }

    dest.salaryTypeId = source.salaryType;
    // const isAlreadyExists = dest.jobTypes.find(x=>x=== source.jobType);
    if(source.jobType) {
      dest.jobTypes = [];
      dest.jobTypes.push(source.jobType);
    }
    dest.locationFilter.workType = source.workType;

    return dest;
  }
}
